Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "BaseModalLayout1003047332",
  {"root":"BaseModalLayout1003047332--root","closeButton":"BaseModalLayout1003047332--closeButton","header":"BaseModalLayout1003047332--header","content":"BaseModalLayout1003047332--content","footer":"BaseModalLayout1003047332--footer","footnote":"BaseModalLayout1003047332--footnote","illustration":"BaseModalLayout1003047332--illustration","modalBoxPadding":"48px"},
  ".BaseModalLayout1003047332--root{background-color:#fff;position:relative;max-height:calc(100vh - (48px * 2));display:flex;flex-direction:column;overflow:hidden;border-radius:8px;box-shadow:0 8px 8px 0 rgba(22,45,61,.12),0 3px 24px 0 rgba(22,45,61,.18)}.BaseModalLayout1003047332--closeButton{position:absolute;right:12px;top:12px}.rtl .BaseModalLayout1003047332--closeButton{left:12px;right:unset}",
  9,
  "BaseModalLayout1003047332"
);
__webpack_require__.stylable.$.register(exports.default)
